import { initialCustomerForm } from '@/constants/customers';
import { Dialog, DialogContent } from '@mui/material';
import CustomersForm from '../customers/CustomersForm';
import DefaultLayout from '../layouts/DefaultLayout';
import { UseFieldArrayReturn, UseFormReturn } from 'react-hook-form';
import { MemberFormFields } from '@/types/businesses';
import { blankBusinessMember } from '@/constants/business';

type BusinessAddCustomerFormProps = {
  formMethods: UseFormReturn<any, any, any>;
  open: boolean;
  setOpen: (value: React.SetStateAction<boolean>) => void;
  company: string;
  advisors: string[];
  members: MemberFormFields[];
  fieldArray: UseFieldArrayReturn<any, 'members', 'id'>;
};

export default function BusinessAddCustomerForm({
  formMethods,
  open,
  setOpen,
  company,
  advisors,
  members,
  fieldArray,
}: BusinessAddCustomerFormProps) {
  function handleAddCustomerSuccess(uuid: string) {
    const lastField = fieldArray.fields.length - 1;
    if (members[lastField].consumer !== '') {
      fieldArray.append(blankBusinessMember);
      formMethods.setValue(`members.${lastField + 1}.consumer`, uuid);
    } else {
      formMethods.setValue(`members.${lastField}.consumer`, uuid);
    }
    setOpen(false);
  }

  return (
    <Dialog fullWidth maxWidth="lg" open={open} onClose={() => setOpen(false)}>
      <DialogContent>
        <DefaultLayout header="Add New Customer">
          <CustomersForm
            onSuccess={handleAddCustomerSuccess}
            onLeave={() => setOpen(false)}
            defaultValues={{
              ...initialCustomerForm,
              company,
              advisors,
            }}
          />
        </DefaultLayout>
      </DialogContent>
    </Dialog>
  );
}
